import React, { ReactNode } from "react";

import { Typography } from "@mui/material";

import { ReactComponent as InfoIcon } from "assets/images/info-icon.svg";

import "./index.scss";

interface InfoBoxProps {
  dataTestId?: string;
  title: string;
  content: ReactNode;
}

const InfoBox: React.FC<InfoBoxProps> = ({ title, content, dataTestId }) => {
  return (
    <div className="info-box" data-testid={dataTestId}>
      <div className="info-icon">
        <InfoIcon />
      </div>
      <div className="info-box-content">
        <Typography variant="subtitle2" color="primary" sx={{ mb: 0.5 }}>
          {title}
        </Typography>
        <Typography variant="body2">{content}</Typography>
      </div>
    </div>
  );
};

export default InfoBox;
